<template>
  <b-modal :id="id" title="Add New Client" @show="resetModal" @hidden="resetModal" @ok="handleOk">
    <b-table
      stacked
      :borderless="true"
      :fields="[
          {
            key: 'username',
            label: 'Username'
          },
          {
            key: 'password',
            label: 'Password',
          },
          {
            key: 'confirmPassword',
            label: 'Confirm Password'
          },
        ]"
      :items="[{
        username,
        password,
        confirmPassword
      }]"
    >
      <template v-slot:cell(username)>
        <b-form-input type="text" v-model="username"></b-form-input>
      </template>
      <template v-slot:cell(password)>
        <b-form-input type="password" v-model="password"></b-form-input>
      </template>
      <template v-slot:cell(confirmPassword)>
        <b-form-input type="password" v-model="confirmPassword"></b-form-input>
      </template>
    </b-table>

    <template v-slot:modal-footer="{ ok, cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="sm" variant="secondary" @click="cancel()">Cancel</b-button>
      <b-button
        size="sm"
        :disabled="!isFormValid ? `disabled` : null "
        variant="primary"
        class="bg-site-primary"
        @click="ok()"
      >Add</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: `ClientAddModal`,
  data() {
    return {
      username: null,
      password: null,
      confirmPassword: null
    };
  },
  props: {
    id: {
      type: String
    }
  },
  computed: {
    isFormValid() {
      if (
        !this.username ||
        !this.password ||
        !this.confirmPassword ||
        this.password != this.confirmPassword
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    filterNumberOnly(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        if (isNaN(this.credits) || this.credits < 0) {
          this.credits = 0;
        }
        return true;
      }
    },
    resetModal() {
      this.username = null;
      this.password = null;
      this.confirmPassword = null;
    },
    handleOk() {
      // Check if Values are complete
      if (!this.isFormValid) {
        return false;
      } else {
        const { username, password } = this;
        const role = 'client'
        this.$store
          .dispatch(`user/create`, {username, password, role })
          .then(() => {
            this.$emit("ok");
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>